import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-redirect-registration',
    templateUrl: './redirect-registration.component.html',
    styleUrls: ['./redirect-registration.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RedirectRegistrationComponent {
  constructor() {}
}
